import React, { useEffect, useRef, useState } from "react";
import * as image from "../../resources/images";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ShimmerCategoryList } from "react-shimmer-effects";
import ReactPlayer from "react-player";
import { NextScene } from "../../redux/actions/APIs";
import { useDispatch } from "react-redux";
const LessonContentLeft = ({ loggedInUser, defaultChildData, currentSceneObj, getMyActivity, getCount, loginType }) => {
    const playerRef = useRef(null);
    const dispatch = useDispatch();
    const [duration, setduration] = useState();
    const [isPLay, setIsPlay] = useState(true);
    const [showVideoTextLine, setShowVideoTextLine] = useState(false);

    const readyTime = (e) => {
        setduration(e.getDuration());
    };

    useEffect(()=>{
        if(currentSceneObj){
            setIsPlay(true);
        }
    },[currentSceneObj])


    const onPrgress = (e) => {
        const seventyFivePercent = 0.85;
        const seventyFiveTime = duration * seventyFivePercent;

    if (!currentSceneObj?.isCompleted && e.playedSeconds >= 5 &&  e.playedSeconds < 16) {
      setShowVideoTextLine(true);
    } else {
      setShowVideoTextLine(false);
    }
        if (
            parseInt(seventyFiveTime.toFixed()) <= e.playedSeconds.toFixed() &&
            loggedInUser?.role?.name !== "PROVIDER" && !currentSceneObj?.isCompleted
        ) {
            let isSkill = true;
            currentSceneObj.isCompleted = true;

            let sceneData = {
                "learnerId": defaultChildData?.id,
                "activityId": getMyActivity?.activityId,
                "courseId": getMyActivity?.courseId,
                "objId": getMyActivity?.skillId,
                "sceneId": currentSceneObj?.id,
                "isComp": isSkill,
                "activityTime": getCount,
                "seriesId": getMyActivity?.series.id,
                "callApi": false,
            }
            dispatch(NextScene(sceneData));
            // console.log("onPrgress @@ 22: ",sceneData, currentSceneObj);
        }
    };


    // console.log("duration @@ : ", duration, currentSceneObj);
    return (
        <div className=''>
            <div className='Course_height'>
                <div className="lessonDtl">
                    <div className="StoryScene">
                        <div className="video_container">
                            {!isPLay && (
                                <>
                                <div className="video_icons pointer">
                                    <img src={image.Video_btn} />
                                </div>
                            </>
                            )}
                            {loginType && showVideoTextLine && (
                                    <div className='videoinfotext'>
                                        <p>
                                            <i className='fa-sharp fa-light fa-circle-info mr-2'></i>
                                            Watch the complete video and earn 10 points!
                                        </p>
                                    </div>
                            )}
                            {loginType && currentSceneObj?.isCompleted && (
                                <div className='videoinfotext checkvideoicon'>
                                        <p className='video_viewedicon'>
                                            <img src={image.enrolledicon} />
                                        </p>
                                </div>
                            )}    
                            {currentSceneObj?.videourl?.endsWith(".mp4") ? (
                                <ReactPlayer
                                    ref={playerRef}
                                    width={"100%"}
                                    height="100%"
                                    controls={true}
                                    className="w-100 br-18"
                                    onPlay={() => setIsPlay(true)}
                                    onPause={() => setIsPlay(false)}
                                    playing={isPLay}
                                    url={currentSceneObj?.videourl}
                                    config={{
                                        file: {
                                            attributes: {
                                                controlsList: "nodownload",
                                            },
                                        },
                                    }}
                                    onReady={(e) => readyTime(e)}
                                    onProgress={(e) => { loginType && onPrgress(e) }}
                                />

                            ) : (
                                <LazyLoadImage
                                    key={currentSceneObj?.imageurl}
                                    effect="blur"
                                    placeholderSrc={currentSceneObj?.imageurl}
                                    src={currentSceneObj?.imageurl}
                                    alt=""
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LessonContentLeft